import {
  zippableSoftwareExtentions,
  zippableSoftwareFolders,
} from "../content/workFileFormatsGroups";

function getExtensionFromPath(path = "") {
  return (String(path).match(/(\.)\w+/g) || []).pop() || "";
}

function normalizeFileType(fileType = "") {
  if (!fileType) return "";
  return "." + String(fileType).toLowerCase();
}

function getFolderMarker(folderRoot = "") {
  const extension = getExtensionFromPath(folderRoot).toLowerCase();
  if (!extension) return null;

  const markerExtension = zippableSoftwareFolders.find(
    (folderExtension) => folderExtension === extension
  );
  if (!markerExtension) return null;

  return {
    type: "folder",
    extension: markerExtension,
    relativePath: folderRoot,
  };
}

function getFileMarker(file = {}) {
  const extension =
    getExtensionFromPath(file.relativePath || file.fileName).toLowerCase() ||
    normalizeFileType(file.fileType);
  if (!extension) return null;

  const markerExtension = zippableSoftwareExtentions.find(
    (fileExtension) => fileExtension === extension
  );
  if (!markerExtension) return null;

  return {
    type: "file",
    extension: markerExtension,
    relativePath: file.relativePath || file.fileName || "",
  };
}

export function getDawFolderMarker(component = {}) {
  const folderMarker = getFolderMarker(component.folderRoot || component.title);
  if (folderMarker) return folderMarker;

  for (const file of component.file || []) {
    const fileMarker = getFileMarker(file);
    if (fileMarker) return fileMarker;
  }

  return null;
}

export function isDawFolderComponent(component = {}) {
  return component.isFolderUpload === true && Boolean(getDawFolderMarker(component));
}
